export default function resizeToImplicitHeight(element: HTMLElement) {
  element.style.height = '1px'
  element.style.height = `${element.scrollHeight + 3}px`
}
